export const UATHeader = 'x-api-302eccb3-6d67-498e-8c02-3483f0e6990b';
